import { ClickablePhotoContentCardDataProps } from '@ahc-digital/component-library';
import { C49ClickablePhotoContentCardProps } from './C49ClickablePhotoContentCard.types';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';

export function CreateC49ClickablePhotoContentCardModel({
  props,
}: {
  props?: C49ClickablePhotoContentCardProps;
  isEditing: boolean;
}): ClickablePhotoContentCardDataProps {
  const { renderText, renderRichText, renderImage, renderLink } = useConditionalRendering();
  const { fields, params } = props || {};

  const model: ClickablePhotoContentCardDataProps = {
    image: renderImage(fields?.Image, { required: true }),
    headline: renderText(fields?.Headline),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    supportCopy: renderRichText(fields?.SupportCopy),
    cta: renderLink(fields?.Cta),
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
    linkTitle: fields?.LinkTitle?.value ?? '',
  };

  return model;
}
